<template>

    <footer class="groupama-footer">
        <div class="groupama-footer-top">
            <div class="groupama-footer-inner">
                <router-link to="/">
                    <svg class="groupama-footer-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 530.52 256.86">
                        <defs>
                            <clipPath id="a">
                                <path d="M125.62,106.78h52.66A56.36,56.36,0,0,1,189.8,96L144.69,80.54a172,172,0,0,0-19.07,26.24m207.13-6.35a34.89,34.89,0,0,1-.11,6.35h94.61A96.37,96.37,0,0,0,424,67.4ZM162.15,62.49l46.18,22.83a162.16,162.16,0,0,1,17.83-7L191,39.2a258.15,258.15,0,0,0-28.87,23.29m153,14.29a34.33,34.33,0,0,1,12,9.12l80-48.83C396.7,25.27,382.57,15.86,365,9.47ZM218.4,22.63,247.67,72.7c4.56-.88,9.15-1.58,13.71-2.08L250.8,9a216.24,216.24,0,0,0-32.4,13.59M305.76,0a166.77,166.77,0,0,0-21.17,1.39L280.27,69.8a119.57,119.57,0,0,1,14.17,1.13L326.62,1A208.42,208.42,0,0,0,305.76,0Z"
                                      style="fill:none"/>
                            </clipPath>
                        </defs>
                        <title>Le groupe Groupama - Assureurs créateurs de confiance</title>
                        <path d="M453.26,197.65c-5.56,0-8.54-1.91-8.54-5.31s2.65-5.15,8-5.48l12.2-.66v10.53a86.17,86.17,0,0,1-11.7.92m3.48-34.34a90.18,90.18,0,0,0-17.08,1.82l1,8.05a100.83,100.83,0,0,1,15.35-1.5c5.8,0,9,2.16,9,6.89v.49l-11.53.67c-12,.5-17.76,4.56-17.76,12.36,0,8.54,5.4,13.27,15.27,13.27,5.06,0,9,0,22.89-2.07v-25c0-10.29-5.47-15-17.09-15m-47.28.33a55.12,55.12,0,0,0-16.67,2.57c-2.82-1.83-6.55-2.57-11-2.57a114.51,114.51,0,0,0-20.49,2.07v38.41h9.54V172.93a64.65,64.65,0,0,1,8.88-.58c6.14,0,9.12,2.73,9.12,9.12v22.65h9.62v-25.3a19.34,19.34,0,0,0-.66-5.23,34.35,34.35,0,0,1,9.54-1.24c6.14,0,9.12,3.07,9.12,9.29v22.48h9.54V178.9c0-11-6.63-15.26-16.59-15.26m-81.7,34c-5.56,0-8.54-1.91-8.54-5.31s2.65-5.15,8-5.48l12.2-.66v10.53a86.17,86.17,0,0,1-11.7.92m3.48-34.34a90.18,90.18,0,0,0-17.08,1.82l1,8.05a100.83,100.83,0,0,1,15.35-1.5c5.8,0,9,2.16,9,6.89v.49l-11.53.67c-12,.5-17.76,4.56-17.76,12.36,0,8.54,5.4,13.27,15.27,13.27,5.06,0,9,0,22.89-2.07v-25c0-10.29-5.47-15-17.09-15m-49.35,33.17a56.16,56.16,0,0,1-11.36-.83v-23.3a79.74,79.74,0,0,1,10.61-.67c8.46,0,11.7,5.48,11.7,12.86,0,6.72-4.31,11.94-10.95,11.94m.58-32.84A135.83,135.83,0,0,0,261,165.55v57.73h9.54V203.87a89.55,89.55,0,0,0,12.69.66c11.36,0,19-8.38,19-20.24-.25-12.44-7.13-20.65-19.74-20.65m-34.75,1.24h-9.63V196.4a83,83,0,0,1-10.86.75c-6,0-9-3.07-9-9.29v-23h-9.62V190.1c0,11,6.72,15.26,16.5,15.26a140.2,140.2,0,0,0,22.57-2.07Zm-70.84,32c-7.39,0-12.36-5.06-12.36-12.69,0-7.47,5-12.36,12.36-12.36s12.19,4.89,12.19,12.36c0,7.63-4.89,12.69-12.19,12.69m0-33.76c-13.11,0-22,8.46-22,21.07,0,12.85,8.87,21.4,22,21.4s21.9-8.55,21.9-21.4c0-12.61-8.88-21.07-21.9-21.07m-27.13.5a151.07,151.07,0,0,0-24.13,2.4v38.08h9.53V173.59c4.82-.41,9.54-.58,14.6-.58Zm-36.91,8H83.06v9.21h20.33v12.28a65.59,65.59,0,0,1-16.59,2.48c-11.78,0-19.66-8-19.66-20,0-11.69,8.71-19.57,21.81-19.57,3.32,0,9,.74,16.68,2.15l2-9.28a82.06,82.06,0,0,0-19.41-2.49c-18.92,0-31.52,11.69-31.52,29.19,0,17.84,12,29.7,30.11,29.7,8.21,0,17-2.24,26-6.14Z"
                              style="fill:#01352c"/>
                        <path d="M416.81,138.72v-3.63h9V131.8H413.2v17.1h12.64v-3.29h-9V142h7.95v-3.26Zm-35.76,1.91v-5.69c.95-.05,2-.05,3-.05,1.91,0,3.35,1,3.35,2.8s-1.44,2.94-3.35,2.94Zm2.69-9c-2.34,0-4.65.12-6.31.22v17.1h3.62v-5h2.69c4.28,0,7.22-2.46,7.22-6.21s-2.94-6.08-7.22-6.08m-29.7.22h-3.65v9.59c0,2.84-1.68,4.5-4.2,4.5s-4.2-1.66-4.2-4.5V131.8h-3.62v9.59c0,4.92,3.09,7.89,7.82,7.89s7.85-3,7.85-7.89Zm-47.56,14.09a5.53,5.53,0,1,1,5.35-5.54,5.22,5.22,0,0,1-5.35,5.54m0-14.47c-5.36,0-9.16,3.57-9.16,8.93s3.8,8.93,9.16,8.93,9.15-3.57,9.15-8.93-3.8-8.93-9.15-8.93M265,140.5v-5.58c1,0,2.09,0,3,0,2,0,3.37.83,3.37,2.72a2.9,2.9,0,0,1-3.12,2.89Zm3.17,3.17,3.52,5.23h4.38l-4.33-6.11a5.73,5.73,0,0,0,3.22-5.18c0-3.87-2.79-6-7-6-2.26,0-5.26.1-6.59.15v17.1H265v-5.23h3.17ZM238,138.87h-9.16v3.24h5.82v3a20.67,20.67,0,0,1-4.58.66,5.17,5.17,0,0,1-5.39-5.51c0-3.22,2.44-5.39,6.09-5.39a38.06,38.06,0,0,1,5,.63l.68-3.34a25.44,25.44,0,0,0-6-.76c-5.76,0-9.58,3.55-9.58,8.86s3.64,9,9.15,9a21.26,21.26,0,0,0,8-1.86Zm-73.72-.15v-3.63h9V131.8H160.65v17.1H173.3v-3.29h-9V142h7.95v-3.26ZM137.94,148.9v-3.24h-8.71V131.8h-3.62v17.1Z"
                              style="fill:#01352c"/>
                        <path d="M520.71,246.75v-5.27h9.81v-2.23H518.31v17.23h12.21v-2.23h-9.81V249h8.74v-2.23Zm-6.41-7.07a22.62,22.62,0,0,0-5.95-.81c-5.78,0-9.5,3.6-9.5,9s3.72,9,9.42,9a21.39,21.39,0,0,0,6.23-1l-.45-2.1a24.72,24.72,0,0,1-5.68.86c-4.2,0-7-2.71-7-6.76,0-3.88,2.56-6.64,7.27-6.64a21.28,21.28,0,0,1,5.17.76Zm-19.71-.43h-2.43V252.5L481.8,239.25h-2.28v17.23h2.4V243.3l10.31,13.18h2.36Zm-27.48,3,3.6,8.19h-7.2Zm-4.56,10.34h9.12l1.7,3.88h2.71l-7.83-17.33H466l-7.83,17.33h2.71Zm-7.78-13.35h-2.41v17.23h2.41Zm-15.4,8.16v-5.93h9.5v-2.23H437v17.23h2.4v-6.84h8.44v-2.23Zm-7.53-8.16h-2.43V252.5l-10.36-13.25h-2.28v17.23h2.41V243.3l10.31,13.18h2.35ZM403.36,254.6a6.73,6.73,0,1,1,6.59-6.74,6.35,6.35,0,0,1-6.59,6.74m0-15.73c-5.37,0-9.12,3.6-9.12,9s3.75,9,9.12,9,9.12-3.6,9.12-9-3.75-9-9.12-9m-11.71.81a22.62,22.62,0,0,0-5.95-.81c-5.78,0-9.5,3.6-9.5,9s3.72,9,9.42,9a21.51,21.51,0,0,0,6.24-1l-.46-2.1a24.72,24.72,0,0,1-5.68.86c-4.2,0-7-2.71-7-6.76,0-3.88,2.56-6.64,7.27-6.64a21.28,21.28,0,0,1,5.17.76Zm-35.16,7.07v-5.27h9.81v-2.23H354.09v17.23H366.3v-2.23h-9.81V249h8.74v-2.23Zm-15.42,7.67c-1.21,0-2.61,0-3.85-.07v-13c1.14,0,2.41-.1,3.52-.1,3.88,0,6.54,2.5,6.54,6.48s-2.66,6.66-6.21,6.66m-.33-15.37c-2.05,0-4.56.12-5.92.2v17.23c1.36.07,4.05.2,6.25.2,5,0,8.74-3.5,8.74-8.92s-3.72-8.71-9.07-8.71m-17.37,1A20.91,20.91,0,0,0,317,239c-3.78,0-6.31,1.93-6.31,5,0,2.71,1.55,3.88,5.37,4.66,2.66.53,5.42.92,5.42,3.22,0,1.82-1.67,2.76-4.1,2.76a18.28,18.28,0,0,1-6.69-1.44l-.61,2.25a20.07,20.07,0,0,0,7.2,1.45c3.87,0,6.63-1.78,6.63-5.25,0-3.27-2.48-4.23-6.28-5-2.94-.61-4.38-1.09-4.38-2.71,0-1.78,1.44-2.72,3.67-2.72a22.23,22.23,0,0,1,5.85,1Zm-27.46,8.36v-7.07c1.32,0,2.43-.07,3.65-.07,2.58,0,4.33,1.09,4.33,3.47s-1.75,3.67-4.15,3.67Zm8.49,8.06h2.91L302.55,250a5.39,5.39,0,0,0,3.72-5.22c0-3.7-2.73-5.65-6.79-5.65-2.07,0-4.48.07-6,.15v17.23h2.41v-5.91h2.94c.43,0,.89,0,1.29,0Zm-15.84-17.23h-2.41v10.08A4.88,4.88,0,0,1,281,254.6c-3.06,0-5.11-2-5.11-5.27V239.25h-2.41v10.08c0,4.64,3,7.53,7.52,7.53s7.58-2.89,7.58-7.53ZM260,246.75v-5.27h9.8v-2.23H257.56v17.23h12.21v-2.23H260V249h8.74v-2.23Zm-12.36-5.27h6.53v-2.23h-15.5v2.23h6.56v15h2.41Zm-17.25.78,3.6,8.19h-7.19ZM225.8,252.6h9.12l1.7,3.88h2.71l-7.83-17.33h-2.28l-7.83,17.33h2.72Zm-17.27-5.85v-5.27h9.83v-2.23H206.12v17.23h12.24v-2.23h-9.83V249h8.76v-2.23Zm7.9-12.92h-3.11l-2.21,3.75h2.46ZM191.3,248.42v-7.07c1.32,0,2.44-.07,3.65-.07,2.59,0,4.33,1.09,4.33,3.47s-1.74,3.67-4.15,3.67Zm8.49,8.06h2.91L197.94,250a5.38,5.38,0,0,0,3.73-5.22c0-3.7-2.74-5.65-6.79-5.65-2.08,0-4.49.07-6,.15v17.23h2.4v-5.91h2.94c.43,0,.89,0,1.29,0Zm-14.9-16.8a22.62,22.62,0,0,0-5.95-.81c-5.78,0-9.5,3.6-9.5,9s3.72,9,9.42,9a21.39,21.39,0,0,0,6.23-1l-.45-2.1a24.79,24.79,0,0,1-5.68.86c-4.2,0-7-2.71-7-6.76,0-3.88,2.56-6.64,7.27-6.64a21.28,21.28,0,0,1,5.17.76Zm-26.09.38a20.86,20.86,0,0,0-6.41-1.09c-3.77,0-6.31,1.93-6.31,5,0,2.71,1.55,3.88,5.37,4.66,2.66.53,5.43.92,5.43,3.22,0,1.82-1.68,2.76-4.11,2.76a18.32,18.32,0,0,1-6.69-1.44l-.6,2.25a20,20,0,0,0,7.19,1.45c3.88,0,6.64-1.78,6.64-5.25,0-3.27-2.49-4.23-6.29-5-2.93-.61-4.38-1.09-4.38-2.71,0-1.78,1.45-2.72,3.68-2.72a22.37,22.37,0,0,1,5.85,1Zm-27.45,8.36v-7.07c1.31,0,2.43-.07,3.64-.07,2.59,0,4.34,1.09,4.34,3.47s-1.75,3.67-4.16,3.67Zm8.48,8.06h2.92L138,250a5.38,5.38,0,0,0,3.73-5.22c0-3.7-2.74-5.65-6.79-5.65-2.08,0-4.49.07-6,.15v17.23h2.41v-5.91h2.93c.43,0,.89,0,1.3,0ZM124,239.25h-2.4v10.08a4.88,4.88,0,0,1-5.17,5.27c-3.07,0-5.12-2-5.12-5.27V239.25h-2.41v10.08c0,4.64,3,7.53,7.53,7.53S124,254,124,249.33Zm-28.59,7.5v-5.27h9.8v-2.23H93v17.23H105.2v-2.23H95.4V249h8.74v-2.23Zm-17.24,1.67v-7.07c1.32,0,2.43-.07,3.65-.07,2.58,0,4.33,1.09,4.33,3.47s-1.75,3.67-4.15,3.67Zm8.49,8.06h2.91L84.8,250a5.39,5.39,0,0,0,3.72-5.22c0-3.7-2.73-5.65-6.79-5.65-2.07,0-4.48.07-6,.15v17.23h2.4v-5.91H81.1c.43,0,.89,0,1.29,0ZM70.81,239.25H68.4v10.08a4.88,4.88,0,0,1-5.17,5.27c-3.06,0-5.11-2-5.11-5.27V239.25H55.71v10.08c0,4.64,3,7.53,7.52,7.53s7.58-2.89,7.58-7.53Zm-19.6.81A20.91,20.91,0,0,0,44.8,239c-3.78,0-6.31,1.93-6.31,5,0,2.71,1.54,3.88,5.37,4.66,2.66.53,5.42.92,5.42,3.22,0,1.82-1.67,2.76-4.1,2.76a18.28,18.28,0,0,1-6.69-1.44l-.61,2.25a20.07,20.07,0,0,0,7.2,1.45c3.87,0,6.63-1.78,6.63-5.25,0-3.27-2.48-4.23-6.28-5-2.94-.61-4.38-1.09-4.38-2.71,0-1.78,1.44-2.72,3.67-2.72a22.23,22.23,0,0,1,5.85,1Zm-17.06,0a20.84,20.84,0,0,0-6.4-1.09c-3.78,0-6.31,1.93-6.31,5,0,2.71,1.54,3.88,5.37,4.66,2.66.53,5.42.92,5.42,3.22,0,1.82-1.67,2.76-4.1,2.76a18.24,18.24,0,0,1-6.69-1.44l-.61,2.25A20.07,20.07,0,0,0,28,256.86c3.88,0,6.64-1.78,6.64-5.25,0-3.27-2.48-4.23-6.28-5C25.44,246,24,245.51,24,243.89c0-1.78,1.44-2.72,3.67-2.72a22.3,22.3,0,0,1,5.85,1ZM9,242.26l3.59,8.19H5.37ZM4.41,252.6h9.12l1.69,3.88h2.71l-7.82-17.33H7.83L0,256.48H2.71Z"
                              style="fill:#01352c"/>
                        <g style="clip-path:url(#a)">
                            <rect x="125.62" width="303.26" height="106.78" style="fill:#01352c"/>
                        </g>
                    </svg>
                </router-link>

                <div class="groupama-footer-socials">
                    <p class="groupama-footer-socials-title">
                        Suivez-nous !
                    </p>

                    <div class="groupama-footer-socials-items">
                        <a href="https://www.facebook.com/groupama" target="_blank" rel="nofollow"
                           class="groupama-footer-socials-item facebook" title="Suivez-nous sur Facebook">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.72 430.11"><title>Suivez-nous sur
                                Facebook</title>
                                <path d="M43.38,83.3v59.22H0v72.41H43.38V430.11h89.13V214.94h59.8s5.6-34.73,8.32-72.69H132.84V92.74c0-7.4,9.72-17.35,19.33-17.35h48.55V0h-66C41.18,0,43.38,72.48,43.38,83.3Z"/>
                            </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/groupama" target="_blank" rel="nofollow"
                           class="groupama-footer-socials-item linkedin"
                           title="Suivez-nous sur Linkedin">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 23">
                                <title>Suivez-nous sur Linkedin</title>
                                <path d="M5,3.5A2.48,2.48,0,1,1,2.5,1,2.49,2.49,0,0,1,5,3.5ZM5,8H0V24H5Zm8,0H8V24h5V15.6c0-4.67,6-5,6,0V24h5V13.87C24,6,15.08,6.28,13,10.16Z"/>
                            </svg>
                        </a>
                        <a href="https://twitter.com/GroupeGroupama?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank" rel="nofollow"
                           class="groupama-footer-socials-item twitter"
                           title="Suivez-nous sur Twitter">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19.5">
                                <title>Suivez-nous sur Twitter</title>
                                <path d="M24,2.31a9.87,9.87,0,0,1-2.83.77A4.94,4.94,0,0,0,23.34.36a10,10,0,0,1-3.13,1.19,4.93,4.93,0,0,0-8.39,4.5A14,14,0,0,1,1.67.9,4.94,4.94,0,0,0,3.19,7.48,5,5,0,0,1,1,6.86a4.94,4.94,0,0,0,4,4.89,4.86,4.86,0,0,1-2.22.08,4.92,4.92,0,0,0,4.6,3.42,9.86,9.86,0,0,1-7.29,2A13.92,13.92,0,0,0,7.55,19.5a13.92,13.92,0,0,0,14-14.64A10.11,10.11,0,0,0,24,2.31Z"/>
                            </svg>
                        </a>
                        <a href="https://www.instagram.com/groupama" target="_blank" rel="nofollow"
                           class="groupama-footer-socials-item instagram"
                           title="Suivez-nous sur Instagram">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                <title>Suivez-nous sur Instagram</title>
                                <path d="M128,23.06c34.18,0,38.23.13,51.72.75,12.48.57,19.26,2.65,23.77,4.41a39.66,39.66,0,0,1,14.72,9.57,39.66,39.66,0,0,1,9.57,14.72c1.76,4.51,3.84,11.29,4.41,23.77.62,13.49.75,17.54.75,51.72s-.13,38.23-.75,51.72c-.57,12.48-2.65,19.26-4.41,23.77a42.33,42.33,0,0,1-24.29,24.29c-4.51,1.76-11.29,3.84-23.77,4.41-13.49.62-17.54.75-51.72.75s-38.23-.13-51.72-.75c-12.48-.57-19.26-2.65-23.77-4.41a39.58,39.58,0,0,1-14.72-9.57,39.58,39.58,0,0,1-9.57-14.72c-1.76-4.51-3.84-11.29-4.41-23.77-.62-13.49-.75-17.54-.75-51.72s.13-38.23.75-51.72C24.38,63.8,26.46,57,28.22,52.51a39.66,39.66,0,0,1,9.57-14.72,39.58,39.58,0,0,1,14.72-9.57C57,26.46,63.8,24.38,76.28,23.81c13.49-.62,17.54-.75,51.72-.75M128,0C93.24,0,88.88.15,75.23.77S52.3,3.56,44.15,6.72A62.88,62.88,0,0,0,21.48,21.48,62.83,62.83,0,0,0,6.72,44.16C3.56,52.3,1.39,61.6.77,75.23S0,93.24,0,128s.15,39.12.77,52.77,2.79,22.93,5.95,31.08a62.88,62.88,0,0,0,14.76,22.67,62.88,62.88,0,0,0,22.67,14.76c8.15,3.16,17.45,5.33,31.08,5.95s18,.77,52.77.77,39.12-.15,52.77-.77,22.93-2.79,31.07-5.95a65.4,65.4,0,0,0,37.44-37.43c3.16-8.15,5.33-17.45,5.95-31.08s.77-18,.77-52.77-.15-39.12-.77-52.77-2.79-22.93-5.95-31.07a62.83,62.83,0,0,0-14.76-22.68A62.83,62.83,0,0,0,211.84,6.72C203.7,3.56,194.4,1.39,180.77.77S162.76,0,128,0Zm0,62.27A65.73,65.73,0,1,0,193.73,128,65.73,65.73,0,0,0,128,62.27Zm0,108.4A42.67,42.67,0,1,1,170.67,128,42.68,42.68,0,0,1,128,170.67Zm83.69-111a15.36,15.36,0,1,1-15.36-15.36A15.36,15.36,0,0,1,211.69,59.67Z"/>
                            </svg>
                        </a>
                    </div>

                </div>

                <languages color="#00352c" hide="title"></languages>

            </div>
        </div>
        <div class="groupama-footer-bot">
            <div class="groupama-footer-inner">
                <p class="groupama-footer-copyright">
                    © GROUPAMA, tous droits réservés
                </p>
                <div class="groupama-footer-links">
                    <a href="https://www.groupama.com/fr/mentions-legales-et-cookies/" target="_blank" class="groupama-footer-links-item">Mentions légales et cookies
                    </a>
                </div>
            </div>
        </div>
    </footer>

</template>

<script>
    export default {
        name: "GroupamaFooter"
    }
</script>

<style scoped lang="scss">


    .groupama-footer {
        background: #006b58;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
        z-index: 999;
        position: relative;

        &-top {
            display: flex;
            padding: 20px 0;
            border-top: 1px solid #00352c;
            border-bottom: 1px solid #00352c;
        }

        &-inner {
            max-width: 1300px;
            width: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &-bot {
            padding-top: 20px;
        }

        &-copyright {
            margin: 0;
            color: #00352c;
            font-size: 14px;
        }

        &-logo {
            display: block;
            width: 149px;
            height: 72px;
        }

        &-socials {
            display: flex;
            flex-direction: column;

            &-title {
                color: #00352c;
                font-size: 16px;
                text-transform: uppercase;
                font-weight: 600;
            }

            &-items {
                display: flex;
                align-items: flex-start;
            }

            &-item {
                width: 35px;
                height: 35px;
                border: 1px solid #00352c;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                margin-right: 15px;
                text-indent: -9999px;
                align-items: center;
                justify-content: center;
                transition: .25s ease;
                box-shadow: 0 0 0px rgba(0, 0, 0, .2);

                &:hover {
                    background: #00352c;
                    transform: scale(1.3);
                    box-shadow: 0 0 5px rgba(0, 0, 0, .2);

                    &.rss {
                        svg {
                            path, circle {
                                stroke: #006b58 !important;
                            }
                        }
                    }

                    svg {
                        animation: shake infinite .3s ease;
                        fill: #006b58;


                    }
                }

                @keyframes shake {
                    0% {
                        transform: rotate(0deg);
                    }

                    25% {
                        transform: rotate(15deg);
                    }

                    50% {
                        transform: rotate(0);
                    }

                    75% {
                        transform: rotate(-15deg);
                    }

                    100% {
                        transform: rotate(0);
                    }
                }


                svg {
                    width: 15px;
                    height: 15px;
                    fill: #00352c;
                    transform-origin: center;
                }

                &.print {
                    svg {
                        width: 17px;
                        height: 15px;
                    }
                }

                &.email {
                    svg {
                        width: 17px;
                        height: 13px;
                    }
                }

                &.facebook {
                    svg {
                        width: 8px;
                        height: 15px;
                    }
                }

                &.rss {
                    svg {
                        width: 13px;
                        height: 13px;

                        path, rect, circle {
                            stroke: #00352c !important;
                        }
                    }
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        &-links {
            display: flex;
            align-items: center;

            &-item {
                color: #00352c;
                display: flex;
                align-items: center;
                font-size: 14px;
                text-decoration: none;

                &::after {
                    display: flex;
                    content: '';
                    width: 1px;
                    height: 10px;
                    background-color: #00352c;
                    margin-left: 6px;
                    margin-right: 6px;
                }

                &:last-child {
                    &::after {
                        content: none;
                    }
                }

            }
        }
    }

    @media screen and (max-width: 1380px) {

        .groupama-footer {
            &-inner {
                max-width: 100%;
                padding: 0 25px;
            }
        }

    }

    @media screen and (max-width: 780px) {

        .groupama-footer {
            height: auto;

            &-top {
                .groupama-footer {
                    &-socials {
                        &-title {
                            margin-top: 0;
                        }
                    }

                    &-inner {
                        align-items: flex-start;
                        max-width: 100%;
                        padding: 0 30px;
                    }
                }

                > div > a {
                    display: none;
                }
            }

            &-bot {
                .groupama-footer {
                    &-inner {
                        flex-direction: column;
                        justify-content: center;
                    }
                }
            }
        }
    }


</style>
